const {
  proxyUrl
} = window.assetUrls;

const [proxyModule] = await Promise.all([
    import(proxyUrl)
]);

const { unsubscribe } = proxyModule;

async function unsubscribeFromQuery() {
  // Parse URL parameters
  const content = document.querySelector("[data-unsubscribe-success]");
  const errorContent = document.querySelector("[data-unsubscribe-error]");
  const loader = document.querySelector("[data-unsubscribe-loader]");
  const urlParams = new URLSearchParams(window.location.search);
  const crmCustomerNo = urlParams.get('k');
  const hash = urlParams.get('h');
  const email = urlParams.get('e');
  const formData = new FormData();
  formData.append('crmCustomerNo', crmCustomerNo);
  formData.append('hash', hash);
  formData.append('email', email);
  const result = await unsubscribe(formData);

  if (!result || result.status == false) {
    console.error('Unsubscribe failed');
    if (errorContent) {
      if (loader) {
        loader.style.display = "none";
      }
      errorContent.classList.remove("hidden");
    }
  } else {
    if (content) {
       if (loader) {
        loader.style.display = "none";
       }
      content.classList.remove("hidden");
    }
  }
}
// Call the function on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    unsubscribeFromQuery().catch(error => {
      console.error('Error unsubscribing:', error);
    });
  });
} else {
  // DOM already loaded
  console.log('Document already loaded, unsubscribing...');
  unsubscribeFromQuery().catch(error => {
    console.error('Error unsubscribing:', error);
  });
}
